module.exports = __webpack_public_path__ + "img/newyearbaydin.db781321.jpg";